import React from 'react'

import { object, string, bool } from 'prop-types'

import Hamburger from './Components/Hamburger/Hamburger'
import Logo from './Components/Logo/Logo'
import Menu from './Components/Menu/Menu'
import Search from './Components/Search/Search'
import UserActions from './Components/UserActions/UserActions'

function Navigation({
  commonRoutes,
  locale = 'en',
  isInListingPage = false,
  searchInputValue = '',
  searchPlaceholder,
}) {
  const { root } = commonRoutes

  return (
    <div className="unified-nav">
      <Hamburger />
      <Logo url={root} />
      <Search
        locale={locale}
        isInListingPage={isInListingPage}
        searchInputValue={searchInputValue}
        searchPlaceholder={searchPlaceholder}
      />
      <Menu />
      <UserActions />
    </div>
  )
}

Navigation.propTypes = {
  commonRoutes: object.isRequired,
  locale: string,
  isInListingPage: bool,
  searchInputValue: string,
  searchPlaceholder: string.isRequired,
}

export default Navigation
